<template>
  <div class="memorandum">
   <!-- <el-row style="margin:0 0 30px 0">
    <el-col :span="3">
         创建时间:
    </el-col>
  <el-col :span="8">
    {{ruleForm.createTime}}
  </el-col>
    <el-col :span="3">
         更新时间:
    </el-col>
  <el-col :span="8">
     {{ruleForm.updateTime}}
  </el-col>
</el-row> -->
<el-form
    :model="ruleForm"
    :rules="rules"
    ref="checkForm"
    label-width="100px"
    label-suffix=":"
  >
  
    <el-form-item label="标题" prop="title">
      <el-input  v-model="ruleForm.title"></el-input>
    </el-form-item>
    <el-form-item label="内容" prop="desc">
      <el-input type="textarea" :rows="10" v-model="ruleForm.desc"></el-input>
    </el-form-item>
  </el-form>
 </div>
</template>
<script>
import PlatformAssist from "@/services/platformassist.service.js";
import { IsNull } from "../../utils/utils";
export default {
  created(){
    PlatformAssist.getMemoRandum().then(res=>{
       if (res.Success) {
           if(res && res.Result){
              this.ruleForm.title=res.Result.Title;
              this.ruleForm.desc=res.Result.Description;
              this.ruleForm.createTime=res.Result.CreateTime;
              this.ruleForm.updateTime=res.Result.UpdateTime;
            }
          }
    })
  },
  data() {
     var title = (rule, value, callback) => {
      if (IsNull(value)) {
        callback(new Error("请输入标题"));
      } else {
        callback();
      }
    };
    var desc = (rule, value, callback) => {
      if (IsNull(value)) {
        callback(new Error("请输入内容"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        title: "",
        desc: "",
        createTime:"",
        updateTime:""
      },
      rules: {
        title: {
          required: true,
          validator: title,
          trigger: "change"
        },
        desc: {
          required: true,
          validator: desc,
          trigger: "change"
        }
      }
    };
  },
  methods: {
    confirmAction: function() {
      return this.$refs.checkForm.validate().then(() => {
           PlatformAssist.SaveMemoRandum({
             "Title":this.ruleForm.title,
             "Description":this.ruleForm.desc
             }).then(res => {
          if (!res.Success) {
            this.$message(res.Message);
            return;
          } else {
          this.$message( {type: "success",
          message: "备忘录保存成功！"});
            this.$emit("modalClose");
          }
        });
      });
    }
  }
};
</script>

<style scoped>
.el-col{
   margin: 0 0 5px 0;
 }
</style>